//Name: Female Dress Sizes
//CODE: DRES
//Age: Adult
const femaleDressSizes =[
  { id: '88', values: [
    {region: "AU", name: "6"},
    {region: "NZ", name: "6"},
    {region: "US", name: "2"},
    {region: "UK", name: "6"},
    {region: "EU", name: "34"}
  ]},
  { id: '89', values: [
    {region: "AU", name: "8"},
    {region: "NZ", name: "8"},
    {region: "US", name: "4"},
    {region: "UK", name: "8"},
    {region: "EU", name: "36"}
  ]},
  { id: '90', values: [
    {region: "AU", name: "10"},
    {region: "NZ", name: "10"},
    {region: "US", name: "6"},
    {region: "UK", name: "10"},
    {region: "EU", name: "38"}
  ]},
  { id: '91', values: [
    {region: "AU", name: "12"},
    {region: "NZ", name: "12"},
    {region: "US", name: "8"},
    {region: "UK", name: "12"},
    {region: "EU", name: "40"}
  ]},
  { id: '92', values: [
    {region: "AU", name: "14"},
    {region: "NZ", name: "14"},
    {region: "US", name: "10"},
    {region: "UK", name: "14"},
    {region: "EU", name: "42"}
  ]},
  { id: '93', values: [
    {region: "AU", name: "16"},
    {region: "NZ", name: "16"},
    {region: "US", name: "12"},
    {region: "UK", name: "16"},
    {region: "EU", name: "44"}
  ]},
  { id: '94', values: [
    {region: "AU", name: "18"},
    {region: "NZ", name: "18"},
    {region: "US", name: "14"},
    {region: "UK", name: "18"},
    {region: "EU", name: "46"}
  ]},
  { id: '183', values: [
    {region: "AU", name: "20"},
    {region: "NZ", name: "20"},
    {region: "US", name: "16"},
    {region: "UK", name: "20"},
    {region: "EU", name: "48"}
  ]},
  { id: '184', values: [
    {region: "AU", name: "22"},
    {region: "NZ", name: "22"},
    {region: "US", name: "18"},
    {region: "UK", name: "22"},
    {region: "EU", name: "50"}
  ]},
  { id: '185', values: [
    {region: "AU", name: "24"},
    {region: "NZ", name: "24"},
    {region: "US", name: "20"},
    {region: "UK", name: "24"},
    {region: "EU", name: "52"}
  ]},
  { id: '186', values: [
    {region: "AU", name: "26"},
    {region: "NZ", name: "26"},
    {region: "US", name: "22"},
    {region: "UK", name: "26"},
    {region: "EU", name: "54"}
  ]}
];

export default femaleDressSizes;



// WEBPACK FOOTER //
// ./src/data/female-dress-sizes.js